// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.client-analytics-page {
  padding-left: 8%;
  overflow: auto;
  max-height: 90vh;
  height: 100%;
  width: 85%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.client-analytics-page__title {
  font-size: 2.5rem;
  font-weight: 500;
  margin-bottom: 0rem;
  display: flex;
  margin-top: 4rem;
}
.client-analytics-page .chip {
  border: 0.0825rem solid #E3E8EC;
  color: #EE926B;
  font-weight: 500;
  background-color: #fff;
}
.client-analytics-page__button-container {
  height: 3rem;
  width: 1140px;
  justify-content: flex-start;
  margin-top: 4rem;
  display: flex;
  flex-direction: row;
  gap: 20px;
}
.client-analytics-page__button-container__button {
  width: 14rem;
  height: 2rem;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 214, 166, 0.4196078431);
  cursor: pointer;
}
.client-analytics-page table {
  height: fit-content;
  border-collapse: collapse;
  width: 70%;
  box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.15);
  margin-bottom: 20px;
}
.client-analytics-page th {
  border: 0.0625rem solid #ddd;
  padding: 0.67rem;
  border-top: none;
}
.client-analytics-page th:first-child {
  border-left: none;
}
.client-analytics-page th:last-child {
  border-right: none;
}
.client-analytics-page td {
  border-left: 0.0625rem solid #ddd;
  border-right: 0.0625rem solid #ddd;
  padding: 1rem;
  text-align: center;
  width: fit-content;
  text-wrap: nowrap;
}
.client-analytics-page td:first-child {
  border-left: none;
}
.client-analytics-page th {
  color: #666;
  font-size: 0.8125rem;
  font-weight: 500;
}
.client-analytics-page .modify {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/features/admin/components/client-analytics/client-analytics.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AACJ;AAAI;EACE,iBAAA;EACF,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAEJ;AAAQ;EACE,+BAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AAEV;AAAQ;EACE,YAAA;EACA,aAAA;EACA,2BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAEV;AADU;EACE,YAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mDAAA;EACA,eAAA;AAGZ;AAAQ;EACI,mBAAA;EACA,yBAAA;EACA,UAAA;EACA,2CAAA;EACA,mBAAA;AAEZ;AACU;EACE,4BAAA;EACA,gBAAA;EACA,gBAAA;AACZ;AAAY;EACI,iBAAA;AAEhB;AAAY;EACI,kBAAA;AAEhB;AACU;EACE,iCAAA;EACA,kCAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AACZ;AACY;EACI,iBAAA;AAChB;AAGU;EACE,WAAA;EACA,oBAAA;EACA,gBAAA;AADZ;AAGU;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;AADZ","sourcesContent":[".client-analytics-page{\n    padding-left: 8%;\n    overflow: auto;\n    max-height: 90vh;\n    height: 100%;\n    width: 85%;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    &__title{\n      font-size: 2.5rem;\n    font-weight: 500;\n    margin-bottom: 0rem;\n    display: flex;\n    margin-top: 4rem;\n    }\n        .chip{\n          border: 0.0825rem solid #E3E8EC;\n          color:#EE926B;\n          font-weight: 500;\n          background-color: #fff;\n        }\n        &__button-container{\n          height: 3rem;\n          width: 1140px;  \n          justify-content: flex-start;    \n          margin-top: 4rem;\n          display: flex;\n          flex-direction: row;\n          gap: 20px;\n          &__button{\n            width: 14rem;\n            height: 2rem;\n            border-radius: 5px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            background-color: #FFD6A66B;\n            cursor: pointer;\n          }\n        }\n        table {\n            height: fit-content;\n            border-collapse: collapse;\n            width: 70%;\n            box-shadow: 0 0 1.25rem rgba(0, 0, 0, 0.15);\n            margin-bottom: 20px;\n          }\n          \n          th {\n            border: 0.0625rem solid #ddd;\n            padding: 0.67rem;\n            border-top: none;\n            &:first-child {\n                border-left: none;\n            }\n            &:last-child {\n                border-right: none;\n            }\n          }\n          td {\n            border-left: 0.0625rem solid #ddd;\n            border-right: 0.0625rem solid #ddd;\n            padding: 1rem;\n            text-align: center;\n            width: fit-content;\n            text-wrap: nowrap;\n          \n            &:first-child {\n                border-left: none;\n            }\n          }\n          \n          th {\n            color: #666;\n            font-size: 0.8125rem;\n            font-weight: 500;\n          }\n          .modify{\n            cursor: pointer;\n            display: flex;\n            flex-direction: row;\n            justify-content: space-around;\n            align-items: center;\n            height: 100%;\n          }\n        }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
